import Vue from 'vue'
import Router from 'vue-router'
import Login from './sites/login.vue'
import Dashboard from './sites/dashboard.vue'
import ParcelList from './sites/parcel-list.vue'
import ReportList from './sites/report-list.vue'
import ReportDetail from './sites/report-detail.vue'
import ReportEdit from './sites/report-edit.vue'
import ExportProofList from './sites/export-proof-list.vue'
import ExportProofDetail from './sites/export-proof-detail.vue'
import ExportProofEdit from './sites/export-proof-edit.vue'
import DropCostReport from './sites/drop-cost-report.vue'
import ParcelDetail from './sites/parcel-detail.vue'
import ParcelBook from './sites/parcel-book.vue'
import BookWithFile from './sites/book-with-file.vue'
import ScanWithFile from './sites/scan-with-file.vue'
import ConsolidatedBook from './sites/consolidated-book.vue'
import EditCreateUser from './admin/edit-create-user.vue'
import CreateUserByFile from './admin/create-user-by-file.vue'
import UserList from './admin/user-list.vue'
import DatabaseTables from './admin/database-tables.vue'
import MaintainInternalNews from './admin/maintain-internal-news.vue'
import PersonalSettings from './admin/personal-settings.vue'
import VerifyUser from './sites/verify-user.vue'
import Styleguide from './sites/styleguide.vue'
import Playground from './sites/playground.vue'
import ProblemReportMeasures from './sites/problem-report-measures.vue'
import PudoManager from './components/pudo/pudo-manager.vue'
import PudoHistory from './components/pudo/pudo-history.vue'
import MatchScan from './sites/match-scan.vue'
import AnonymousTracking from './sites/anonymous-tracking.vue'
import DeadlineList from './sites/deadline-list.vue'
import DeadlineEdit from './sites/deadline-edit.vue'
import DailyCargoDetailTable from './components/daily-cargo/detail/daily-cargo-detail-table.vue'
import DailyCargoDataEdit from './components/daily-cargo/edit/daily-cargo-data-edit.vue'
import DailyCargoList from './sites/daily-cargo-list.vue'
import DailyCargoGeneral from './sites/daily-cargo-general.vue'
import DailyCargoRacNumber from './components/daily-cargo/rac-validation/daily-cargo-rac-number.vue'
import DailyCargoRacValidation from './components/daily-cargo/rac-validation/daily-cargo-rac-validation.vue'
import DailyCargoIdentityCheckSheet from './components/daily-cargo/identity-check-sheet/daily-cargo-identity-check-sheet.vue'
import DailyCargoEditIdentityCheckSheet from './components/daily-cargo/identity-check-sheet/daily-cargo-edit-identity-check-sheet.vue'
import DailyCargoEditRacNumber from './components/daily-cargo/rac-validation/daily-cargo-edit-rac-number.vue'
import DailyCargoDriverAdministration from './components/daily-cargo/driver-administration/daily-cargo-driver-administration.vue'
import DailyCargoEditDriverAdministration from './components/daily-cargo/driver-administration/daily-cargo-edit-driver-administration.vue'
import DailyCargoFlightAdministration from './components/daily-cargo/flight-administration/daily-cargo-flight-administration.vue'
import DailyCargoEditFlightAdministration from './components/daily-cargo/flight-administration/daily-cargo-edit-flight-administration.vue'
import AdhocDriveList from './sites/adhoc-drive-list.vue'
import AdhocDriveEdit from './sites/adhoc-drive-edit.vue'
import PreCarriageList from './sites/precarriage-list.vue'
import UpdateWithFile from '@/sites/update-with-file.vue'
import LinehaulRoadList from './sites/linehaul-road-list.vue'
import LinehaulRoadEdit from './sites/linehaul-road-edit.vue'

Vue.use(Router)

// Suppress NavigationDuplicated / NavigationRedirected errors in Vue Router 3
// Vue Router 3 marks all navigation failures with _isRouter = true
const originalPush = Router.prototype.push as Function
Router.prototype.push = function push (location: any, onResolve?: any, onReject?: any) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch((err: any) => {
    if (err && err._isRouter) return err
    throw err
  })
}

const originalReplace = Router.prototype.replace as Function
Router.prototype.replace = function replace (location: any, onResolve?: any, onReject?: any) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch((err: any) => {
    if (err && err._isRouter) return err
    throw err
  })
}

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'start',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: AnonymousTracking
    },
    {
      path: '/styleguide',
      name: 'styleguide',
      component: Styleguide
    },
    {
      path: '/dashboard/:from_date?/:to_date?/:customer_id?/:country_id?/:service_level_id?/:status?/:current_event_infos?/:show_forward_flow?/:from_postal_code?/:to_postal_code?/:providers?/:tags?',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/parcel-list/:from_date?/:to_date?/:customer_id?/:country_id?/:service_level_id?/:status?/:current_event_infos?/:show_forward_flow?/:from_postal_code?/:to_postal_code?/:providers?/:tags?',
      name: 'parcel-list',
      component: ParcelList
    },
    {
      path: '/report-list/:from_date?/:to_date?/:customer_id?/:country_id?/:service_level_id?/:status?/:current_event_infos?/:show_forward_flow?/:from_postal_code?/:to_postal_code?/:providers?/:tags?',
      name: 'report-list',
      component: ReportList
    },
    {
      path: '/report-detail/:id',
      name: 'report-detail',
      component: ReportDetail
    },
    {
      path: '/report-create',
      name: 'report-create',
      component: ReportEdit
    },
    {
      path: '/report-edit/:id',
      name: 'report-edit',
      component: ReportEdit
    },
    {
      path: '/drop-cost-report',
      name: 'drop-cost-report',
      component: DropCostReport
    },
    {
      path: '/export-proof-list/:from_date?/:to_date?/:customer_id?/:country_id?/:service_level_id?/:status?/:current_event_infos?/:show_forward_flow?/:from_postal_code?/:to_postal_code?/:providers?/:tags?',
      name: 'export-proof-list',
      component: ExportProofList
    },
    {
      path: '/export-proof-detail/:id',
      name: 'export-proof-detail',
      component: ExportProofDetail
    },
    {
      path: '/export-proof-create',
      name: 'export-proof-create',
      component: ExportProofEdit
    },
    {
      path: '/export-proof-edit/:id',
      name: 'export-proof-edit',
      component: ExportProofEdit
    },
    {
      path: '/parcel-detail/:id',
      name: 'parcel-detail',
      component: ParcelDetail
    },
    {
      path: '/parcel-book/:return_id?',
      name: 'parcel-book',
      component: ParcelBook
    },
    {
      path: '/consolidated-book',
      name: 'consolidated-book',
      component: ConsolidatedBook
    },
    {
      path: '/book-with-file',
      name: 'book-with-file',
      component: BookWithFile
    },
    {
      path: '/update-with-file',
      name: 'update-with-file',
      component: UpdateWithFile
    },
    {
      path: '/scan-with-file',
      name: 'scan-with-file',
      component: ScanWithFile
    },
    {
      path: '/expiry-manager',
      name: 'expiry-manager',
      component: PudoManager
    },
    {
      path: '/expiry-history',
      name: 'expiry-history',
      component: PudoHistory
    },
    {
      path: '/daily-cargo-detail-table',
      name: 'daily-cargo-detail-table',
      component: DailyCargoDetailTable
    },
    {
      path: '/daily-cargo-identity-check-sheet',
      name: 'daily-cargo-identity-check-sheet',
      component: DailyCargoIdentityCheckSheet
    },
    {
      path: '/daily-cargo-edit-identity-check-sheet',
      name: 'daily-cargo-edit-identity-check-sheet',
      component: DailyCargoEditIdentityCheckSheet
    },
    {
      path: '/daily-cargo-driver-administration',
      name: 'daily-cargo-driver-administration',
      component: DailyCargoDriverAdministration
    },
    {
      path: '/daily-cargo-flight-administration',
      name: 'daily-cargo-flight-administration',
      component: DailyCargoFlightAdministration
    },
    {
      path: '/daily-cargo-edit-flight-administration',
      name: 'daily-cargo-edit-flight-administration',
      component: DailyCargoEditFlightAdministration
    },
    {
      path: '/daily-cargo-edit-driver-administration',
      name: 'daily-cargo-edit-driver-administration',
      component: DailyCargoEditDriverAdministration
    },
    {
      path: '/daily-cargo-edit-driver-administration/:id',
      name: 'daily-cargo-edit-driver-administration',
      component: DailyCargoEditDriverAdministration
    },
    {
      path: '/daily-cargo-data-edit',
      name: 'daily-cargo-data-edit',
      component: DailyCargoDataEdit
    },
    {
      path: '/daily-cargo-list',
      name: 'daily-cargo-list',
      component: DailyCargoList
    },
    {
      path: '/daily-cargo-rac-number',
      name: 'daily-cargo-rac-number',
      component: DailyCargoRacNumber
    },
    {
      path: '/daily-cargo-edit-rac-number',
      name: 'daily-cargo-edit-rac-number',
      component: DailyCargoEditRacNumber
    },
    {
      path: '/daily-cargo-rac-validation',
      name: 'daily-cargo-rac-validation',
      component: DailyCargoRacValidation
    },
    {
      path: '/daily-cargo-general',
      name: 'daily-cargo-general',
      component: DailyCargoGeneral
    },
    {
      path: '/daily-cargo-general/:id',
      name: 'daily-cargo-general',
      component: DailyCargoGeneral
    },
    {
      path: '/match-scan',
      name: 'match-scan',
      component: MatchScan
    },
    {
      path: '/problem-report-measures',
      name: 'problem-report-measures',
      component: ProblemReportMeasures
    },
    {
      path: '/admin/user-list',
      name: 'user-list',
      component: UserList
    },
    {
      path: '/admin/database-tables',
      name: 'database-tables',
      component: DatabaseTables
    },
    {
      path: '/admin/create-user',
      name: 'create-user',
      component: EditCreateUser
    },
    {
      path: '/admin/create-user-by-file',
      name: 'create-user-by-file',
      component: CreateUserByFile
    },
    {
      path: '/admin/edit-user/:user_id',
      name: 'edit-user',
      component: EditCreateUser
    },
    {
      path: '/verify-user',
      name: 'verify-user',
      component: VerifyUser
    },
    {
      path: '/admin/maintain-internal-news',
      name: 'maintain-internal-news',
      component: MaintainInternalNews
    },
    {
      path: '/admin/personal-settings',
      name: 'personal-settings',
      component: PersonalSettings
    },
    {
      path: '/playground',
      name: 'playground',
      component: Playground
    },
    {
      path: '/deadline-list',
      name: 'deadline-list',
      component: DeadlineList
    },
    {
      path: '/adhoc-drive-list',
      name: 'adhoc-drive-list',
      component: AdhocDriveList
    },
    {
      path: '/precarriage-list',
      name: 'precarriage-list',
      component: PreCarriageList
    },
    {
      path: '/adhoc-drive-edit/:id',
      name: 'adhoc-drive-edit',
      component: AdhocDriveEdit
    },
    {
      path: '/adhoc-drive-create',
      name: 'adhoc-drive-create',
      component: AdhocDriveEdit
    },
    {
      path: '/deadline-edit/:id',
      name: 'deadline-edit',
      component: DeadlineEdit
    },
    {
      path: '/deadline-create',
      name: 'deadline-create',
      component: DeadlineEdit
    },
    {
      path: '/linehaul-road-list',
      name: 'linehaul-road-list',
      component: LinehaulRoadList
    },
    {
      path: '/linehaul-road-edit/:id',
      name: 'linehaul-road-edit',
      component: LinehaulRoadEdit
    },
    {
      path: '/linehaul-road-create',
      name: 'linehaul-road-create',
      component: LinehaulRoadEdit
    }
  ]
})

export default router
